interface IStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

enum Locals {
  LANGUAGE = "LANGUAGE",
}

abstract class Storage<T extends string> {
  private readonly storage: IStorage;

  public constructor(getStorage = (): IStorage => window.localStorage) {
    this.storage = getStorage();
  }

  protected get(key: T): string | null {
    return this.storage.getItem(key);
  }

  protected set(key: T, value: string): void {
    this.storage.setItem(key, value);
  }

  protected clearItem(key: T): void {
    this.storage.removeItem(key);
  }

  protected clearItems(keys: T[]): void {
    keys.forEach((key) => this.clearItem(key));
  }
}

export class UUIDStorage extends Storage<Locals> {
  private static instance?: UUIDStorage;

  private constructor() {
    super();
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new UUIDStorage();
    }

    return this.instance;
  }

  public getLanguage() {
    return this.get(Locals.LANGUAGE) ?? "en";
  }

  public setLanguage(language: string) {
    this.set(Locals.LANGUAGE, language);
  }
}
